import { getPartners } from '../views/reactViews/ApiUtil';
import { SESSION_SPONSORS_FETCHED } from '../constants/ActionTypes';
import { levels as levelsDefaultValues} from 'defaultSponsorLevelsEnum';

export const sponsorsByEventFetched = data => ({
    type: SESSION_SPONSORS_FETCHED,
    data
});

export const getTireConfiguration = configuration =>
    configuration
        ? configuration
        : levelsDefaultValues;

export const fetchSponsorsByEvent = (event) =>
    async(dispatch, getState) => {
        try {
            const response = await getPartners({eventId: event.id});
            const { eventReducer } = getState();
            const tierConfiguration = getTireConfiguration(eventReducer.event['tier-configuration']);
            if (response['event-partners']) {
                if (!Array.isArray(response['event-partners'].sponsors)) {
                    const sponsorsObject = response['event-partners'].sponsors;
                    response['event-partners'].sponsors = sponsorsObject ? [{...sponsorsObject}] : [];
                }
                response['event-partners'].sponsors.map(sponsor => {
                    if (sponsor.tier) {
                        const tierProperty = tierConfiguration.find(level => level.tier === sponsor.tier);
                        if (tierProperty) {
                            if (typeof tierProperty.color === 'number') {
                                tierProperty.color = `#${tierProperty.color}`;
                            }
                            if (!tierProperty.color.includes('#')) {
                                tierProperty.color = `#${tierProperty.color}`;
                            }
                            sponsor.tierProperty = tierProperty;
                        } else {
                            delete sponsor.tier;
                        }
                    }
                    return { ...sponsor };
                });
            } else {
                response['event-partners'] = { sponsors: [] };
            }
            return dispatch(sponsorsByEventFetched(response));
        } catch (err) {
            throw err;
        }
    };
